import { Check, X } from 'lucide-react'
import { validatePassword, type PasswordValidation } from '@/lib/utils'

interface PasswordValidationProps {
  password: string
}

export function PasswordValidation({ password }: PasswordValidationProps) {
  const validation = validatePassword(password)

  const validationItems = [
    {
      key: 'hasNumber',
      label: 'Contains at least 1 number',
      valid: validation.hasNumber,
    },
    {
      key: 'hasSpecialChar',
      label: 'Contains at least 1 special character',
      valid: validation.hasSpecialChar,
    },
    {
      key: 'hasUppercase',
      label: 'Contains at least 1 uppercase letter',
      valid: validation.hasUppercase,
    },
    {
      key: 'hasLowercase',
      label: 'Contains at least 1 lowercase letter',
      valid: validation.hasLowercase,
    },
  ]

  // Don't show validation if password is empty
  if (!password) return null

  return (
    <div className="mt-2 space-y-1">
      <p className="text-xs font-medium text-gray-700 dark:text-gray-300">
        Password requirements:
      </p>
      {validationItems.map(item => (
        <div key={item.key} className="flex items-center gap-2 text-xs">
          {item.valid ? (
            <Check className="h-3 w-3 text-green-600" />
          ) : (
            <X className="h-3 w-3 text-red-500" />
          )}
          <span
            className={
              item.valid
                ? 'text-green-700 dark:text-green-400'
                : 'text-red-600 dark:text-red-400'
            }
          >
            {item.label}
          </span>
        </div>
      ))}
    </div>
  )
}
